// extracted by mini-css-extract-plugin
module.exports = {"window":"DefaultWindow_window__2jd3U","header":"DefaultWindow_header__2fjwg","footer":"DefaultWindow_footer__2a0h7","content":"DefaultWindow_content__3no6A"};